module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE2SURBVHgBlZRBToNAFIbfP0NDjRuOwBHoDeqOVO8g7oiregLrCXRlSFxYT2BNtDFxAUfwCByBVY0KPGdqm7QwhOm3GIb8ky8vb14GtGE8Ze94VUcsuFgmzpwOAHoJY/al4GdiCvQ/A7PlPW5sJUIvEpxuBWsz82xyyde2EoTx71hCpqbwp8To4wGffRLhAF5X6MrSIwuE48pMfQtDVrwmg4wsEIs7FMT80o6QkyXrxg6GYtquhoMz1S8Lx79EV8NcXzVDhnwM4y/fSqLRA6autjkbvoSb7or0vilG03oaV3MCzqkFMnXaU/1rDSTIQLdon60IXQesRVxfiK7wLZGRoUcG4KPvyCQuI0Dcqq1pevOKv09En0TfWsUYqbqfTIL35CjvrWQX/WQ4qIKayVsN5SLT0674A/GZeeIFSX9dAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stroke-1.png
// module id = nsOS
// module chunks = 1